import React from "react";
import TitleToolTip from "./TitleToolTip";

const LabelToolTip = (props) => {
  const { label, className, labelLengthToShow = 40 } = props;
  return label.length <= labelLengthToShow ? (
    // if length is smaller than the labelLengthToShow then show the label without tooltip
    <span className={className}>{label}</span>
  ) : (
    <TitleToolTip
      title={label}
      children={
        String(label).slice(0, labelLengthToShow) +
        (label.length > labelLengthToShow ? "..." : "")
      }
      childrenClassName={className}
    />
  );
};

export default LabelToolTip;
